import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'

import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text, { Title } from '../../../../../../packages/kiti/components/presentation/Text'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import ServiceOrderStatusSelect from '../../../../../../containers/statuses/select/ServiceOrderStatusSelect'

const UpdateStatusSentence = () => {
  const { t } = useTranslation('triggers')
  const [open, setOpen] = React.useState()
  const { form } = useFormState()
  const title = form.action === 'update_status' ? t('actions.update_status') : t('actions.update_parent_status')

  const dataToChange = () => {
    let value = '_______'

    const status = form.payload.status
    if (status) {
      value = status.label
    }
    return value
  }

  return (
    <>
      <Text size="h2">{t('updateStatus.to')} </Text>
      <EditableSentence label={dataToChange()} truncate={20} onClick={() => setOpen(true)} field="payload" />

      <Modal open={open} onClose={() => setOpen(false)} width="28rem">
        <Title size="h5" bold>
          {title}
        </Title>
        <Separator weight={4} />

        <Grid paddingGutter={0.5} wrap>
          <Col width="100%">
            <FormItem label={t('updateStatus.status')} path={['payload', 'status']} Input={ServiceOrderStatusSelect} />
          </Col>
        </Grid>
        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default UpdateStatusSentence
